import styled, { css } from 'styled-components';
import { SelectOption } from '../../types';
import { ValueContainerProps } from 'react-select';
import { colors, space } from '@ardoq/design-tokens';

const defaultStyle = css`
  display: flex;
  flex: 1 1 0%;
  flex-wrap: wrap;
  overflow-wrap: anywhere;
  gap: ${space.xsmall};
`;

const hiddenStyle = css`
  width: 0;
  border-right: 1px solid ${colors.borderNeutral};
`;

export const ValueContainerStyle = styled.div<{ $isHidden?: boolean }>`
  position: relative;
  overflow: hidden;
  ${({ $isHidden }) => ($isHidden ? hiddenStyle : defaultStyle)}
`;

export const ValueContainer = (
  props: ValueContainerProps<SelectOption<unknown>>
) => {
  const selectedOption = props.isMulti ? [] : props.getValue();
  const hasContent = Boolean(
    selectedOption.length > 0 && selectedOption[0].customData
  );
  return (
    <ValueContainerStyle $isHidden={hasContent}>
      {props.children}
    </ValueContainerStyle>
  );
};
